import { MutationFunction, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { App } from 'antd';

import { queryClient } from '@/lib/react-query';
import { axiosClient } from '@/lib/axios';

type NotificationsParams = {
  companyID: number;
  notificationID: number;
};

type NotificationsResponse = {
  message: string;
};

export const deleteNotification = async ({
  companyID,
  notificationID,
}: NotificationsParams): Promise<NotificationsResponse> => {
  const { data } = await axiosClient.delete<NotificationsResponse>(
    `/companies/${companyID}/notifications/${notificationID}`,
  );
  return data;
};

type UseDeleteNotificationOptions = {
  companyID: number;
  notificationID?: number;
  config?: MutationFunction<typeof deleteNotification>;
  postSuccess?: () => void;
};

export const useDeleteNotifications = ({ companyID, postSuccess, config }: UseDeleteNotificationOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error: AxiosError<{ message: string }>) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data?.message,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['notifications'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['company', companyID],
      });

      postSuccess?.();
    },
    ...config,
    mutationFn: deleteNotification,
  });
};
